export const regexName = "^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ ]+$";
export const regexSurname = "^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ -]+$";
export const regexEmail = "^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$";
export const regexPhone = '^([+]?)[0-9]{9}([0-9]{2})?';
